import gql from 'graphql-tag';

export const GET_ALL_BOOST_DATA_QUERY = gql`
  query GetAllBoostData($offerId: Int!) {
    boostDataForAllAffiliatesInOffer(offerId: $offerId) {
      boost {
        activeEndDate
        activeStartDate
        boostMetadata
        boostType
        createdDate
        discountOfferId #can be used to redirect to the boost offer
        hideInCreatorPortal
        id
        isActive
        label
        maxLimit
        requireApproval
        triggerType
        triggerValue
        updatedDate
        discountOffer {
          promos {
            priceRuleType
            priceRuleAmount
          }
        }
        boostEligibility {
            id
            createdDate
            eligibilityType
            memberIds
            updatedDate
            advancedSelectionMetadata
            advancedSelectionOperator
          }
      }
      boostRewardsForAffiliate {
        boostId
        createdDate
        deletedDate
        id
        isActive
        secureCode {
          externalDiscountCode
          isRedeemed
        }
        secureCodeId
        status
        updatedDate
        affiliateId
        shopifyOrderEvent {
          orderStatusUrl
        }
        boostRewardMetadata
        affiliateId
        rewardSpendAmount
      }
    }
  }
`;
